<template>
    <div id="stockSelectSearch">
        <div class="inline-block flex-col w-full sm:w-auto mb-1">
            <div class="relative w-full">
                <input aria-label="Enter a symbol" class="form-input-inline-w-none form-input-sm-inline w-full" style="padding-right:1.5rem !important;" placeholder="Enter a symbol..." autocomplete="off" type="text" @keyup.esc="showResults = false" @keyup.enter="selectFirst" @input="search" v-model="query" name="query" />
                <i @click="close" class="fas fa-times absolute top-0 right-0 pt-2 -mt-px mr-2 text-gray-500 cursor-pointer" v-if="query"></i>
            </div>
            <div class="absolute left-0 md:inset-auto w-full sm:min-w-sm md:min-w-md max-h-96 max-w-md overflow-auto z-50 bg-white border mt-1 p-3 shadow-md rounded" v-if="showResults">
                <div class="relative">
                    <table class="table table-hover searchResult">
                        <tbody>
                            <tr v-for="result in results" @click="selectSymbol(result)" :key="result.name">
                                <td><span v-html="result.symbolDisplay"></span></td>
                                <td><span v-html="result.name"></span></td>
                                <td class="text-right"><span v-html="result.exchange"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    modelValue: [String, Number, Object],
});

const query = ref(null);
const results = ref([]);
const showResults = ref(false);

const emit = defineEmits();

const close = () => {
    query.value = null;
    showResults.value = false;
};

const selectFirst = () => {
    if (results.value.length === 0) return;

    const first = results.value[0];
    query.value = '';
    emitRequest(first.symbol);
    showResults.value = false;
};

const emitRequest = (symbol) => {
    emit('update:modelValue', symbol);
};

const search = () => {
    const route = window.route('api.search');

    showResults.value = false;
    axios
        .post(route, { query: query.value })
        .then((response) => {
            results.value = response.data.instruments;

            const regex = new RegExp('(' + query.value + ')', 'gi');

            if (results.value.length > 0) {
                for (var i = 0; i < results.value.length; i++) {
                    results.value[i].symbolDisplay = results.value[i].symbol.replace(regex, '<b>$1</b>');
                    results.value[i].name = results.value[i].name.replace(regex, '<b>$1</b>');
                    results.value[i].exchange = results.value[i].exchange.replace(regex, '<b>$1</b>');
                }

                emitRequest(results.value[0].symbol);
                showResults.value = true;
            } else {
                showResults.value = false;
            }
        })
        .catch((error) => { });
};

const selectSymbol = (result) => {
    query.value = result.symbol = result.symbol.replace(/(<([^>]+)>)/ig, '');
    showResults.value = false;
    emitRequest(result.symbol);
};

// maybe it's not needed
watch(query, () => {
    search();
});

defineExpose({
    selectFirst
});
</script>

<style lang="scss">
#stockSelectSearch {
    .searchResult {
        @apply text-sm;

        tr:first-of-type td {
            border-top: none !important;
        }

        tr {
            @apply cursor-pointer;
        }

        td {
            @apply px-3 py-1;

            b {
                @apply font-bold text-blue-400;
            }
        }

        em:hover {
            @apply text-blue-500 bg-gray-super-200 cursor-pointer;
        }
    }
}
</style>
